<template>
  <div>
    <Loading v-if="isLoading"></Loading>
    <div v-else>
    <br/>
     <CRow>
        <CCol lg="3">
            <div class="product-group">
                <label for="product_group">Foto KTP</label>
                <div @click="previewImages(items.ktp)" style="cursor: pointer">
                    <CImg :src=" 'https://storage.googleapis.com/isikulkas/' + items.ktp + '?r=' +  unixTime " :thumbnail="true"/>
                </div> 
            </div>             
        </CCol>
        <CCol lg="3">
            <div class="product-group">
                <label for="product_group">Foto Selfie</label>
                <div @click="previewImages(items.selfie)" style="cursor: pointer">
                    <CImg :src=" 'https://storage.googleapis.com/isikulkas/' + items.selfie + '?r=' +  unixTime " :thumbnail="true"  />
                </div>
            </div>
        </CCol>
        <CCol lg="3">
            <div class="product-group">
                <label for="product_group">Foto KK</label>
                <div @click="previewImages(items.kk)" style="cursor: pointer">
                    <CImg :src=" 'https://storage.googleapis.com/isikulkas/' + items.kk + '?r=' +  unixTime " :thumbnail="true"  />
                </div>   
            </div>           
        </CCol>
    </CRow>
    </div>
    <CModal
      title="Image Preview"
      color="success"
      size="lg"
      :closeOnBackdrop="false"
      :show.sync="preview"
    >
      <CImg :src="'https://storage.googleapis.com/isikulkas/'+showImages+'?r='+unixTime" :thumbnail="true" />
    
    </CModal>
  </div>
</template>

<script>
import GlobalTable from "@/templates/Table";
import Loading from "@/templates/Loading";

export default {
  name: "UserDocument",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "User Request Freezer Detail",
      unixTime: Math.floor(Math.random() * (0 - 9999999999 + 1)) + 0,
      showImages: "",
      preview: false
    };
  },
  props: {
    items: {
      type: [Array, Object],
      default: () => [],
    },
    isLoading: {
        type: Boolean,
        default: false
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function (id) {
    },
    back: function () {
      this.$router.go(-1);
    },
    
    previewImages: function (img) {
        this.showImages = "";
        this.preview = true;
        this.showImages = img;
    },
  
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
